import type { SaveBarStatus } from "./save-bar.type";

import { SAVE_BAR_STATUS } from "./save-bar.enum";

export const getSaveBarStatus = (hasChanges?: boolean): SaveBarStatus => {
  return hasChanges ? SAVE_BAR_STATUS.WARNING : SAVE_BAR_STATUS.SUCCESS;
};
